import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from "../../../shared";
import { ActiveTaskReportResponseDto } from '../../../../data-transfer-objects/alg/cc/active-task-report-response-dto.model';

@Injectable({ providedIn: 'root' })
export class ActiveTaskReport extends BaseApiTemplateService<ActiveTaskReportResponseDto> {
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'reports/active-task-report';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'reports/active-task-report';
    this.httpClient = theHttp;
    }   

    getActiveTaskReport(pagination: Pagination, visa: ApiVisa, appletGuid: string): Observable<PagingResponseModel<ActiveTaskReportResponseDto>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      const UrlByCriteria = this.apiUrl + '?appletGuid=' + appletGuid + '&' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<ActiveTaskReportResponseDto>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }   
}
